import * as angular from 'angular';
import {IController} from "angular";
import * as _ from "lodash";
import {OmsOrderStatusType} from "../../types/oms-order-status.type";

export class OmsOrderStatusMultiSelectListComponent implements IController {
  statuses: OmsOrderStatusType[];
  options: any;
  ngPlaceholder: any;
  onChange: Function;

  private selectedKeys: any;

  constructor() {
  }

  $onInit() {
    if (!this.options || !this.options.length) {
      this.options = angular.copy(Object.values(OmsOrderStatusType));
    }
  }

  $onChanges(changes) {
    if (changes.statuses) {
      this.selectedKeys = [];
      _.forEach(this.statuses, (status) => {
        this.selectedKeys[status] = true;
      })
    }
  }

  //////////////////////////////////////////////////////////////////////////////////////////////////////////////////////

  onToggle(option, isSelected) {
    this.onChange({
      statuses: isSelected ? _.concat(this.statuses || [], [option]) :
        _.filter(this.statuses, (status) => {
          return status !== option;
        })
    });
  }

  onReset() {
    this.onChange({statuses: []});
  }

}

angular
  .module('bringoz.admin.oms')
  .component('omsOrderStatusMultiSelectList', {
    bindings: {
      statuses: '<',
      options: '<?',
      ngPlaceholder: '@?',
      onChange: '&'
    },
    template: require('./oms-order-status-multi-select-list.html').default,
    controller: OmsOrderStatusMultiSelectListComponent
  });

